<template>
  <div>
    <div class="row row-space-10">
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-teal m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-utensils fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">TOTAL PRODUCT</div>
            <div class="stats-number">{{ product.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="product.percentages + '%'"
                class="progress-bar"
                :style="{ width: product.percentages + '%' }"
              ></div>
            </div>
            <!-- <div class="stats-desc">Female ({{ product.female }})</div> -->
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-blue m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-project-diagram fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">TOTAL PRODUCT CATEGORY</div>
            <div class="stats-number">{{ category.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="category.percentages + '%'"
                class="progress-bar"
                :style="{ width: category.percentages + '%' }"
              ></div>
            </div>
            <!-- <div class="stats-desc">Female ({{ category.female }})</div> -->
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-purple m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-sitemap fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">TOTAL PRODUCT GROUP</div>
            <div class="stats-number">{{ productGroup.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="productGroup.percentages + '%'"
                class="progress-bar"
                :style="{ width: productGroup.percentages + '%' }"
              ></div>
            </div>
            <!-- <div class="stats-desc">Used App ({{ productGroup.usedApp }})</div> -->
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-3 col-md-6">
        <div class="widget widget-stats bg-gradient-black m-b-10">
          <div class="stats-icon stats-icon-lg">
            <i class="fas fa-users fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">TOTAL VENDOR</div>
            <div class="stats-number">{{ vendor.total }}</div>
            <div class="stats-progress progress">
              <div
                v-tooltip="vendor.percentages + '%'"
                class="progress-bar"
                :style="{ width: vendor.percentages + '%' }"
              ></div>
            </div>
            <!-- <div class="stats-desc">Current vendors ({{ vendor.current }})</div> -->
          </div>
        </div>
      </div>
      <!-- end col-3 -->
    </div>
    <!-- end row -->
  </div>
</template>
<script>
export default {
  name: 'totalCard',
  data () {
    return {
      loading: false,
      products: null,
      categories: null,
      product_groups: null,
      vendors: null
    }
  },
  computed: {
    product () {
      if (this.products) {
        return this.products
      }
      return 0
    },
    category () {
      if (this.categories) {
        return this.categories
      }
      return 0
    },
    productGroup () {
      if (this.product_groups) {
        return this.product_groups
      }
      return 0
    },
    vendor () {
      if (this.vendors) {
        return this.vendors
      }
      return 0
    }
  },
  methods: {
    fetchTotal () {
      this.$store
        .dispatch('dashboard/widget/fetchTotal')
        .then(responses => {
          this.products = responses.products
          this.categories = responses.categories
          this.product_groups = responses.product_groups
          this.vendors = responses.vendors
          this.loading = false
        })
        .catch(() => {
          // this.$toasted.error(error.message)
          this.loading = false
        })
    }
  }
}
</script>
